module.exports = __webpack_public_path__ + "static/media/29 Knee on Belly.52656a6a.jpg";